import AppLayout from '@/components/AppLayout';
import { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from 'react-router-dom';

import { setNavigate } from '@/utils/navigation';
import ReceiptPage from '@/views/billing/receipt';
import Dashboard from '@/views/dashboard';
import Forbidden from '@/views/error/Forbidden';
import InternalServerError from '@/views/error/InternalServerError';
import NotFound from '@/views/error/NotFound';
import RouteErrorBoundary from './RouteErrorBoundary';
import { useRoutes } from './route-loader';

export const NavigationSetup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};

export const AppRouter = () => {
  const routes = useRoutes();

  const router = createBrowserRouter([
    {
      // Pathless root that catches all chunk load failures and render errors
      errorElement: <RouteErrorBoundary />,
      children: [
        {
          path: '/',
          element: (
            <>
              <NavigationSetup />
              <AppLayout />
            </>
          ),
          children: [
            {
              path: '/',
              index: true,
              element: <Dashboard />,
            },
            ...routes,
          ],
        },
        {
          path: '/billing/receipt',
          element: <ReceiptPage />,
        },
        {
          path: '/404',
          element: <NotFound />,
        },
        {
          path: '/403',
          element: <Forbidden />,
        },
        {
          path: '/500',
          element: <InternalServerError />,
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
  ]);

  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  );
};
